import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function SparklesIcon({ color, className }) {
    return (
        <svg
            width="11"
            height="13"
            viewBox="0 0 11 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M3.42595 12.8753C3.70486 11.1218 5.01379 9.72265 6.69646 9.35105C6.73464 9.34282 6.73464 9.28808 6.69646 9.27944C5.01379 8.90784 3.70486 7.5091 3.42595 5.75563C3.41952 5.71447 3.36245 5.71447 3.35562 5.75563C3.07672 7.5091 1.76779 8.90784 0.0851111 9.27944C0.0469322 9.28767 0.0469322 9.3424 0.0851111 9.35105C1.76779 9.72265 3.07712 11.1218 3.35562 12.8749C3.36205 12.916 3.41912 12.916 3.42595 12.8749V12.8753Z"
                fill={color}
            />
            <path
                d="M2.3196 3.86592C2.45194 3.0339 3.07303 2.37001 3.87145 2.19368C3.88957 2.18978 3.88957 2.16381 3.87145 2.15971C3.07303 1.98339 2.45194 1.31969 2.3196 0.487667C2.31655 0.468141 2.28948 0.468141 2.28623 0.487667C2.15389 1.31969 1.53281 1.98339 0.734385 2.15971C0.716269 2.16361 0.716269 2.18958 0.734385 2.19368C1.53281 2.37001 2.15408 3.0339 2.28623 3.86573C2.28928 3.88525 2.31636 3.88525 2.3196 3.86573V3.86592Z"
                fill={color}
            />
            <path
                d="M8.05266 6.73366C8.24057 5.55227 9.12245 4.6096 10.2561 4.35923C10.2819 4.35369 10.2819 4.31681 10.2561 4.31099C9.12245 4.06063 8.24057 3.11823 8.05266 1.93684C8.04832 1.90911 8.00987 1.90911 8.00527 1.93684C7.81736 3.11823 6.93548 4.06063 5.80178 4.31099C5.77606 4.31654 5.77606 4.35341 5.80178 4.35923C6.93548 4.6096 7.81763 5.55227 8.00527 6.73339C8.0096 6.76111 8.04805 6.76111 8.05266 6.73339V6.73366Z"
                fill={color}
            />
        </svg>
    );
}

SparklesIcon.propTypes = propTypes;
SparklesIcon.defaultProps = defaultProps;

export default SparklesIcon;
